import React from 'react';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import ProgressBar from '@atlaskit/progress-bar';
import { InfoFlag } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const IN_PROGRESS_FLAG_ID = 'paid-list-ninconfig-migration-in-progress';

export const InProgressFlag = () => {
	const { formatMessage } = useIntl();
	return (
		<InfoFlag
			appearance="normal"
			id={IN_PROGRESS_FLAG_ID}
			title={formatMessage(messages.listMigrationInProgressTitle)}
			description={
				<Box>
					<Stack space="space.100">
						{formatMessage(messages.listMigrationInProgressDescription)}
						<ProgressBar isIndeterminate />
					</Stack>
				</Box>
			}
		/>
	);
};
